import AddItemCommand from "./AddItemCommand";
import ReomveCommand from './ReomveCommand'
import { INIT_Y } from '../../variable/constant'
class CopyCommand {
    constructor(id, env) {
        this.id = id;
        this.env = env;
        this.newId = null;
        this.newPosition = null;
        this.containChange=true;
    }
    async do() {
        for (let flowerObject of this.env.objects.flowers) {
            if (this.id === flowerObject.id) {
                const sourcePosition = flowerObject.modelMesh.flowerMesh.position;
                const params = {
                    resourceId: flowerObject.resource.id,
                    params: JSON.parse(JSON.stringify(flowerObject.params)),
                    position: this.newPosition || {
                        x: sourcePosition.x,
                        y: INIT_Y,
                        z: sourcePosition.z
                    }
                };
                this.newId = await new AddItemCommand(params, this.env).do();
                const copiedFlower = this.env.objects.flowers.find(item => item.id === this.newId);
                if (copiedFlower && copiedFlower.modelMesh.flowerMesh) {
                    const position = copiedFlower.modelMesh.flowerMesh.position;
                    this.newPosition = { x: position.x, y: position.y, z: position.z };
                }
                return this.newId;
            }
        }
    }
    prev() {
        new ReomveCommand(this.newId, this.env).do();
    }
}

export default CopyCommand;
